import { useContext } from 'react';
import { TaskManagerContext } from './taskManagerContext';

const useTaskManager = () => useContext(TaskManagerContext);

export default useTaskManager;
